<p>outer-frame-product-configuration works!</p>
<div>
  <!--NestedFrames-->
  <div>
    <!--NestedFrames for loop for display FrameOptions -->
    <div>
      <app-frame-options-product-configuration></app-frame-options-product-configuration>
    </div>
  </div>
  <!--FrameOptions-->
  <app-frame-options-product-configuration></app-frame-options-product-configuration>
</div>

